import { render, staticRenderFns } from "./LessonSources.vue?vue&type=template&id=13471d0a&scoped=true&"
import script from "./LessonSources.vue?vue&type=script&lang=ts&"
export * from "./LessonSources.vue?vue&type=script&lang=ts&"
import style0 from "./LessonSources.vue?vue&type=style&index=0&id=13471d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13471d0a",
  null
  
)

export default component.exports